<template>
  <div class="my-layout-box p-product-center">
    <list-view
      :getList="getList"
      :isTabsShow="isTabsShow"
      :isButtonShow="isButtonShow"
      :isSearchShow="isSearchShow"
      :listMap="listMap"
      :tabList="tabList"
      @changeTab="changeTab"
    >
    </list-view>
  </div>
</template>

<script>
import listView from "~/components/List/ListView.vue";
import { productData, customsProductData } from "./config";
import { getProductCenter, getQueryCustomsProduct } from "~/api/productCenter";

export default {
  name: "stockMessage",
  components: {
    listView
  },
  data() {
    return {
      isTabsShow: true,
      isButtonShow: false,
      isSearchShow: true,
      listMap: productData,
      tabType: 0,
      tabList: [{ title: "我的产品" }, { title: "报关商品查询" }]
    };
  },
  methods: {
    async getList(pagination, searchData) {
      const { tabType } = this;
      let sendData = {
        page: pagination.page,
        limit: pagination.size
      };

      let list = null;
      if (tabType == 0) {
        this.listMap = productData;
        sendData.AgentOrderNo = searchData.value || "";
        list = await getProductCenter(sendData);
      } else if (tabType == 1) {
        sendData.PartNo = searchData.value || "";
        this.listMap = customsProductData;
        if (!sendData.PartNo) {
          return;
        }
        list = await getQueryCustomsProduct(sendData);
      }

      const data = {
        List: list.Items,
        Total: list.Total
      };
      return data;
    },
    changeTab(type) {
      this.tabType = type;
    }
  }
};
</script>

<style lang="less" scope></style>
